import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { HotelItinerary } from "redmond";
import { resetHotelCfarCancellation } from "../../../../actions/actions";
import {
  getHotelCfarCancellationPolicyCallExpires,
  getSelectedHotelCfarReservationId,
} from "../../../../reducer";

export const useRefreshHotelCfarPolicy = (
  hotelItinerary: HotelItinerary,
  options: {
    enabled: boolean;
  }
) => {
  const dispatch = useDispatch();
  const hotelCfarCancellationPolicyCallExpires = useSelector(
    getHotelCfarCancellationPolicyCallExpires
  );
  const selectedHotelCfarReservationId = useSelector(
    getSelectedHotelCfarReservationId
  );

  const isExpired = useMemo(
    () =>
      hotelCfarCancellationPolicyCallExpires != null &&
      hotelCfarCancellationPolicyCallExpires < Date.now(),
    [hotelCfarCancellationPolicyCallExpires]
  );

  const isDifferentReservation = useMemo(
    () =>
      selectedHotelCfarReservationId !==
      hotelItinerary.reservation.reservationBookingId,
    [
      selectedHotelCfarReservationId,
      hotelItinerary.reservation.reservationBookingId,
    ]
  );

  useEffect(() => {
    if (!options.enabled) {
      return;
    }
    if (isExpired || isDifferentReservation) {
      dispatch(resetHotelCfarCancellation());
    }
  }, [isExpired, isDifferentReservation, dispatch, options.enabled]);
};
